/// <amd-module name="Repos/Changes/Components/Discussion/FileDiscussionWidget" />
import { IDiffDiscussionWidget } from "Repos/Discussion/Common/DiscussionContracts";
import { IReadonlyObservableArray, ObservableLike } from "VSS/Core/Observable";
import { IEditorWidgetRegistration } from "VSS/Features/Monaco/Contracts";

type IDiscussionWidgetType = IEditorWidgetRegistration | IDiffDiscussionWidget;

export interface IFileDiscussionWidgetProps {
    className?: string;
    widgets?: IDiscussionWidgetType[] | IReadonlyObservableArray<IDiscussionWidgetType>;
}

export const FileDiscussionWidget = (props: IFileDiscussionWidgetProps): JSX.Element | null => {
    const { className, widgets } = props;

    // Get file level discussion widget
    const allWidgets = widgets ? ObservableLike.getValue(widgets) : [];
    const fileLevelDiscussionWidget = allWidgets.filter(w => {
        const discussionWidget = w as IDiffDiscussionWidget;
        return discussionWidget.isAttachedToFile && discussionWidget.isAttachedToFile();
    })[0] as IDiffDiscussionWidget;

    if (fileLevelDiscussionWidget && fileLevelDiscussionWidget.render) {
        return fileLevelDiscussionWidget.render({ className });
    }

    return null;
};
